import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  leaders: any;
  selectedLang: any;

  @Output() valueChanged: EventEmitter<string> = new EventEmitter();

  constructor(
    private translateService: TranslateService,
  ) { }

  ngOnInit(): void {
    if (localStorage.getItem('lang')) {
      this.selectedLang = localStorage.getItem('lang') ? JSON.parse(localStorage.getItem('lang')) : ''
      this.translateService.use(this.selectedLang.code)
    }
  }

  

  languageChange(event) {
    this.valueChanged.emit(this.selectedLang);

    localStorage.setItem('lang', JSON.stringify(event.value))
    this.translateService.use(event.value.code)
  }
}
